<template>
  <div class="row q-col-gutter-lg q-mb-lg">
    <div
      v-for="(data, index) of statisticalCards"
      :key="index"
      class="col-6 col-md-3"
    >
      <q-card class="text-grey-6" flat bordered>
        <q-card-section class="column items-center q-pt-lg">
          <q-icon :name="data.icon" size="lg" class="q-mb-xs" />
          <span class="text-h5 text-grey-7">
            {{ $numeral(data.value).format('0,0') }}
          </span>
          <span>{{ data.label }}</span>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import { getDashboard } from '@/api/dashboard';

let initialData = {};

export default {
  meta() {
    return {
      title: this.$t('pages.dashboard.documentTitle'),
    };
  },
  data() {
    return {
      error: initialData.error,
      statisticalData: initialData.statisticalData,
    };
  },
  computed: {
    statisticalCards() {
      return [
        {
          icon: 'fas fa-user-md',
          value: this.statisticalData.doctors,
          label: this.$t('pages.dashboard.stats.doctors'),
        },
        {
          icon: 'fas fa-diagnoses',
          value: this.statisticalData.patients,
          label: this.$t('pages.dashboard.stats.patients'),
        },
        {
          icon: 'fas fa-weight',
          value: this.statisticalData.exams,
          label: this.$t('pages.dashboard.stats.exams'),
        },
        {
          icon: 'fas fa-cloud-upload-alt',
          value: this.statisticalData.calls,
          label: this.$t('pages.dashboard.stats.apiCalls'),
        },
      ];
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const statisticalData = await getDashboard();

      initialData.statisticalData = statisticalData;
    } catch (error) {
      initialData.error = error;
    } finally {
      next();
    }
  },
};
</script>
